import { Route, Routes } from "react-router-dom";

import { ROLE } from "../../Constant";
import { PrivateRoute } from "../components/PrivateRoute";
import HoaDon from "./hoa-don";
import LichSuThanhToan from "./lich-su-thanh-toan";
import ThongBaoSaiSot from "./thong-bao-sai-sot";
import ToKhaiDangKy from "./to-khai-dang-ky";
import BangTongHopTransferLog from "./bang-tong-hop";

export default function LichSuTruyenNhan() {
  return (
    <Routes>
      <Route
        path="/hoa-don/*"
        element={
          <PrivateRoute role={ROLE.MGATEWAY_INVOICE}>
            {" "}
            <HoaDon />
          </PrivateRoute>
        }
      />
      <Route
        path="/thong-bao-sai-sot/*"
        element={
          <PrivateRoute role={ROLE.MGATEWAY_WRONG_INVOICE}>
            {" "}
            <ThongBaoSaiSot />
          </PrivateRoute>
        }
      />
      <Route
        path="/to-khai-dang-ky/*"
        element={
          <PrivateRoute role={ROLE.MGATEWAY_DECLARE}>
            {" "}
            <ToKhaiDangKy />
          </PrivateRoute>
        }
      />
      <Route path="/lich-su-thanh-toan*" element={<LichSuThanhToan />} />
      <Route
        path='/bang-tong-hop/*'
        element={
          <PrivateRoute role={ROLE.MGATEWAY_INVOICE_SUMMARY}>
            {" "}
            <BangTongHopTransferLog />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}
